import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ErrorTypes, PromotionsFlowInterface, StateTypes } from '@central-products/interface-promotions-flow';
import { Jurisdiction, Environment, RoutingStrategy } from './types';
import { loadMicroApp } from '@central-products/script-module-loader'; // tslint:disable-next-line

var noop = function noop() {};

export var PromotionsFlow = /*#__PURE__*/function (_PromotionsFlowInterf) {
  _inherits(PromotionsFlow, _PromotionsFlowInterf);

  var _super = _createSuper(PromotionsFlow);

  function PromotionsFlow(config, dependencies) {
    var _this;

    _classCallCheck(this, PromotionsFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", StateTypes.STOPPED);

    _defineProperty(_assertThisInitialized(_this), "startSuccessCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "startErrorCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "stopSuccessCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "stopErrorCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "stateChangedCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "viewChangedCallback", noop);

    _defineProperty(_assertThisInitialized(_this), "gameLaunchCallback", noop);

    if (!config.environment || _Object$values(Environment).indexOf(config.environment) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_ENVIRONMENT
      };
    }

    if (!config.jurisdiction || _Object$values(Jurisdiction).indexOf(config.jurisdiction) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_JURISDICTION
      };
    }

    if (!config.routingStrategy || _Object$values(RoutingStrategy).indexOf(config.routingStrategy) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_ROUTING_STRATEGY
      };
    }

    if (!config.helpPageUrls) {
      throw {
        error: ErrorTypes.MISSING_PARAM_HELP_PAGE_URLS
      };
    }

    if (!config.defaultLangCode) {
      throw {
        error: ErrorTypes.MISSING_PARAM_DEFAULT_LANG_CODE
      };
    }

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(PromotionsFlow, [{
    key: "onStartSuccess",
    value: function onStartSuccess(callback) {
      this.startSuccessCallback = callback;
    }
  }, {
    key: "onStartError",
    value: function onStartError(callback) {
      this.startErrorCallback = callback;
    }
  }, {
    key: "onStopSuccess",
    value: function onStopSuccess(callback) {
      this.stopSuccessCallback = callback;
    }
  }, {
    key: "onStopError",
    value: function onStopError(callback) {
      this.stopErrorCallback = callback;
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.stateChangedCallback = callback;
    }
  }, {
    key: "onViewChanged",
    value: function onViewChanged(callback) {
      this.viewChangedCallback = callback;
    }
  }, {
    key: "onGameLaunch",
    value: function onGameLaunch(callback) {
      this.gameLaunchCallback = callback;
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var _this2 = this;

        var containerSelector, viewMode, domNode, onStartSuccess, onStartError, onStopSuccess, onStopError, onViewChanged, onGameLaunch, _this$config, jurisdiction, environment, defaultLangCode, helpPageUrls, routingStrategy, vertical, refresh, routes, gameLauncher, microAppLoaderConfig, openResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                containerSelector = _ref.containerSelector, viewMode = _ref.viewMode;
                _context.prev = 1;

                if (!(this.state === StateTypes.STARTED)) {
                  _context.next = 4;
                  break;
                }

                throw {
                  error: ErrorTypes.PROMOTIONS_ALREADY_STARTED
                };

              case 4:
                if (containerSelector) {
                  _context.next = 6;
                  break;
                }

                throw {
                  error: ErrorTypes.MISSING_PARAM_CONTAINER_SELECTOR
                };

              case 6:
                domNode = document.querySelector(containerSelector);

                if (domNode) {
                  _context.next = 9;
                  break;
                }

                throw {
                  error: ErrorTypes.COULD_NOT_FIND_DOM_NODE_FOR_PROMOTIONS
                };

              case 9:
                onStartSuccess = function onStartSuccess() {
                  _this2.startSuccessCallback();
                };

                onStartError = function onStartError(error) {
                  _this2.startErrorCallback(error);
                };

                onStopSuccess = function onStopSuccess() {
                  _this2.stopSuccessCallback();
                };

                onStopError = function onStopError(error) {
                  _this2.stopErrorCallback(error);
                };

                onViewChanged = function onViewChanged(payload) {
                  _this2.viewChangedCallback(payload);
                };

                onGameLaunch = function onGameLaunch(payload) {
                  _this2.gameLaunchCallback(payload);
                };

                _this$config = this.config, jurisdiction = _this$config.jurisdiction, environment = _this$config.environment, defaultLangCode = _this$config.defaultLangCode, helpPageUrls = _this$config.helpPageUrls, routingStrategy = _this$config.routingStrategy, vertical = _this$config.vertical, refresh = _this$config.refresh, routes = _this$config.routes, gameLauncher = _this$config.gameLauncher;
                microAppLoaderConfig = {
                  name: 'promotions',
                  environment: environment,
                  jurisdiction: jurisdiction,
                  dependencies: {
                    React: React,
                    ReactDOM: ReactDOM
                  }
                };
                _context.next = 19;
                return loadMicroApp(microAppLoaderConfig);

              case 19:
                openResult = window.WH['cp-apps'].promotions.open({
                  jurisdiction: jurisdiction,
                  environment: environment,
                  defaultLangCode: defaultLangCode,
                  helpPageUrls: helpPageUrls,
                  routingStrategy: routingStrategy,
                  vertical: vertical,
                  refresh: refresh,
                  routes: routes,
                  gameLauncher: gameLauncher,
                  viewMode: viewMode,
                  graphqlClient: this.dependencies['data-access-service'],
                  dependencies: this.dependencies,
                  onOpenError: onStartError,
                  onOpenSuccess: onStartSuccess,
                  onCloseError: onStopError,
                  onCloseSuccess: onStopSuccess,
                  onViewChanged: onViewChanged,
                  onGameLaunch: onGameLaunch
                }, domNode);

                if (!(openResult === undefined)) {
                  _context.next = 22;
                  break;
                }

                throw {
                  error: ErrorTypes.PROMOTIONS_ALREADY_STARTED
                };

              case 22:
                if (!(openResult === false)) {
                  _context.next = 24;
                  break;
                }

                throw {
                  error: ErrorTypes.COULD_NOT_START_PROMOTIONS
                };

              case 24:
                this.changeState(StateTypes.STARTED);
                this.startSuccessCallback();
                return _context.abrupt("return", _Promise.resolve({}));

              case 29:
                _context.prev = 29;
                _context.t0 = _context["catch"](1);
                this.startErrorCallback(_context.t0);
                return _context.abrupt("return", _Promise.reject(_context.t0));

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 29]]);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var closeResult;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(this.state === StateTypes.STOPPED)) {
                  _context2.next = 3;
                  break;
                }

                throw {
                  error: ErrorTypes.PROMOTIONS_ALREADY_STOPPED
                };

              case 3:
                closeResult = window.WH['cp-apps'].promotions.close();

                if (!(closeResult === undefined)) {
                  _context2.next = 6;
                  break;
                }

                throw {
                  error: ErrorTypes.PROMOTIONS_ALREADY_STOPPED
                };

              case 6:
                if (!(closeResult === false)) {
                  _context2.next = 8;
                  break;
                }

                throw {
                  error: ErrorTypes.COULD_NOT_STOP_PROMOTIONS
                };

              case 8:
                this.changeState(StateTypes.STOPPED);
                this.stopSuccessCallback();
                return _context2.abrupt("return", _Promise.resolve({}));

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                this.stopErrorCallback(_context2.t0);
                return _context2.abrupt("return", _Promise.reject(_context2.t0));

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _Promise.resolve({
                  state: this.state
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "showDetails",
    value: function () {
      var _showDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.state === StateTypes.STARTED) {
                  window.WH['cp-apps'].promotions.methods.showDetails(payload);
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function showDetails(_x2) {
        return _showDetails.apply(this, arguments);
      }

      return showDetails;
    }()
  }, {
    key: "showList",
    value: function () {
      var _showList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.state === StateTypes.STARTED) {
                  window.WH['cp-apps'].promotions.methods.showList(payload);
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function showList(_x3) {
        return _showList.apply(this, arguments);
      }

      return showList;
    }()
  }, {
    key: "changeState",
    value: function changeState(state) {
      if (state !== this.state) {
        this.state = state;

        if (this.stateChangedCallback) {
          this.stateChangedCallback({
            state: state
          });
        }
      }
    }
  }]);

  return PromotionsFlow;
}(PromotionsFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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